import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CartDialogPage } from './cart-dialog.page';
import { ElvisDSModule } from 'ngx-elvis-ds';
import { GUIBaseModule } from 'src/app/gui/gui-base/gui-base.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GUIBaseModule,
        ElvisDSModule
    ],
    declarations: [
        CartDialogPage
    ]
})
export class CartDialogPageModule {}
